import styled from 'styled-components'
import { iPadDown } from '../../styles/mediaQueries'

interface ContentProps {
  mobileGridRatio?: string
}

export const Content = styled.div<ContentProps>`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  padding: 1.64vw 0;

  ${iPadDown} {
    padding: 5.07vw 0;
    ${({ mobileGridRatio }) =>
      mobileGridRatio ? `grid-template-columns: ${mobileGridRatio};` : ''}
  }

  > div {
    &:nth-child(2) {
      text-align: center;
    }

    &:last-child {
      text-align: right;
    }
  }
`
